import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, idString, nullableBoolean, nullableString } from '../utils/wire-value-utils';

/**
 * One member of an organization as GET /admin/organizations/:id/memberships returns it (hub
 * `admin-organization-memberships-controller.ts`), per the agreed `ADMIN_MEMBER_READABLE` list. The hub keys
 * members by `membershipId` (copied into `id`) and `profileId`. Read-only: role changes go through
 * `OrganizationMembershipService`.
 */
export class AdminMemberView extends Base {
  membershipId: string;
  profileId: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** Membership role bits (Pilot / PIC). */
  role: number;
  /** `role` plus the Owner / Chief Supervisor bits the hub derives from the organization. */
  combinedRole: number;
  isOwner: boolean;
  isChiefSupervisor: boolean;
  hasAcceptedInvite?: boolean | null;
  isActive: boolean;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.membershipId = idString(source['membershipId']);
    this.id = this.membershipId;
    this.profileId = idString(source['profileId']);
    this.email = nullableString(source['email']);
    this.firstName = nullableString(source['firstName']);
    this.lastName = nullableString(source['lastName']);
    this.role = countOrZero(source['role']);
    this.combinedRole = countOrZero(source['combinedRole']);
    this.isOwner = source['isOwner'] === true;
    this.isChiefSupervisor = source['isChiefSupervisor'] === true;
    this.hasAcceptedInvite = nullableBoolean(source['hasAcceptedInvite']);
    this.isActive = source['isActive'] === true;
  }
}

